import React, { useState, memo, useCallback, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ServiceBase from "utils/ServiceBase";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";

// images
import icon_phone_cancel from "assets/icon_phone_cancel.png";

// components
import PhoneRing from "./PhoneRing";
import Header from "components/headers";
import TimeoutCallStaffModal from "containers/call-staff/TimeoutCallStaffModal";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import { webEventExtraParams } from "utils";
import { emitRateTipAutoOpenTriggerByAction } from "utils/rateTipAutoOpen";

const CaffStaff = memo(({ className }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");
  const [iShowModal, setShowModal] = useState(false);
  const isLanguageEnglish = useSelector(
    (state) => state.rootReducer.isLanguageEnglish,
  );
  const consent = localStorage.getItem("cookieConsent");
  const location = useLocation();
  const categories = location.state?.page || "";
  const infoUserTgs = useSelector((state) => state.rootReducer.infoUserTgs);
  const homeBrand = useSelector((state) => state.rootReducer.homeBrand);

  const onCloseModal = () => {
    onCancel();
  };

  const onCancel = useCallback(() => {
    emitRateTipAutoOpenTriggerByAction("endCall", {
      path: location.pathname,
    });
    if (categories !== "") {
      navigate("/categories");
    } else {
      navigate(-1);
    }
  }, []);

  useEffect(() => {
    viewPageToCdp();
    callStaffCdpEvent();
    let timer = setInterval(() => {
      setShowModal(true);
    }, 30000);
    return () => clearInterval(timer);
  });

  const callStaffCdpEvent = () => {
    let dim = {};
    if (infoUserTgs && consent === "accepted") {
      dim = {
        customers: {
          customer_id: CryptoJS.MD5(infoUserTgs?.["cellphone"]).toString(),
          name: infoUserTgs?.["first-name"] + " " + infoUserTgs?.["last-name"],
          email: infoUserTgs?.["email"],
          phone: infoUserTgs?.["cellphone"],
          ggg_user_id: infoUserTgs?.["customer-number"],
        },
        purchase: {
          id: homeBrand.qrCode,
          name: homeBrand.qrCode,
        },
      };
    } else {
      dim = {
        purchase: {
          id: homeBrand.qrCode,
          name: homeBrand.qrCode,
        },
      };
    }
    window.web_event.track("staff", "call", {
      dims: dim,
      extra: {
        language: isLanguageEnglish ? "eng" : "vie",
        ggg_user_id: infoUserTgs ? infoUserTgs?.["customer-number"] : "",
        ...webEventExtraParams(homeBrand)
      },
    });
  };

  const viewPageToCdp = () => {
    window.web_event.track("pageview", "view", {
      custom_event: 1,
      dims: {},
      extra: {
        page_type: "call-staff",
        language: isLanguageEnglish ? "eng" : "vie",
        ...webEventExtraParams(homeBrand)
      },
    });
  };

  return (
    <div className={className}>
      <div className="box">
        <Modal
          className={"custom-modal-rating"}
          destroyOnClose
          open={iShowModal}
          footer={null}
          centered
          closable={false}
          onCancel={onCloseModal}
        >
          <TimeoutCallStaffModal onClose={onCloseModal} isShow={iShowModal} />
        </Modal>
        <div className="row header">
          <Header title={t("callStaffTitle")} />
        </div>
        <div className="row content flex justify-center items-center flex-col">
          <PhoneRing />
          <div className="font-700 fs-16"> {t("callingStaff")} ...</div>
        </div>
        <div className="row footer">
          <div
            onClick={onCancel}
            className="cursor-pointer items-center flex flex-col mb-20 mt-20"
          >
            <img src={icon_phone_cancel} className="w-14" alt="cancel" />
            <div className=" fs-13 cursor-pointer mt-2 ">{t("endCall")}</div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default styled(CaffStaff)`
  height: 100%;
  .box {
    display: flex;
    flex-flow: column;
    height: 100%;
  }

  .box .row.header {
    flex: 0 1 auto;
  }

  .box .row.content {
    flex: 1 1 auto;
  }

  .box .row.footer {
    flex: 0 1 40px;
  }
`;
